<template>
  <div style="margin-top: 5px" v-if="this.venue && this.venue.name">
    <hr />
    <h3
      class="section-header"
      style=" font-size: 1.3rem"
    >
      LOCATION</h3>
    <router-link
      :to="{ path:  this.venue.slug }"
      class="btn-link btn-sm"
      style="font-size: 1rem"
    >
      📍 {{ this.venue.name }}
    </router-link>

    <br>
    <address itemscope itemtype="https://schema.org/Place" v-if="eventSchema.location" style="margin: 10px">
      <span itemprop="name">{{ eventSchema.location.name }}</span><br>
      <span itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
    <span itemprop="streetAddress">{{ eventSchema.location.address.streetAddress }}</span><br>
    <span itemprop="addressLocality">{{ eventSchema.location.address.addressLocality }}</span>,     <span
        itemprop="addressCountry">MX</span><br>

  </span>

    </address>

    <br />
  </div>
</template>
<script>
export default {
  name: 'EventLocation',
  props: {
    venue: {},
    eventSchema: {}
  }
};
</script>
